<template>
  <div class="container login-register-wrapper-box-container">
    <div class="row my-5 justify-content-center">
      <div class="col-lg-7 col-12">
        <div class="container my-3">
          <ContainerBox class="position-relative">
            <div class="d-flex flex-column gap-4" style="padding: 30px">
              <div class="title-2 text-grey-900">
                {{ t("loginRegister.link_expired") }}
              </div>
              <div class="body text-grey-900">
                {{ t("loginRegister.text_resend_link") }}
              </div>
              <div>
                <Button @buttonClick="handleButtonClick">
                  <template #text>
                    <span>
                      {{ t("loginRegister.button_resend_link") }}
                    </span>
                  </template>
                </Button>
              </div>
            </div>
          </ContainerBox>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import {
    reactive,
    defineProps,
    defineEmits,
    onMounted,
    onBeforeUnmount,
    ref,
  } from 'vue'

  import { onKeyStroke } from '@vueuse/core'

  // logic
  import resetPassword from '@/logic/contact/resetPassword'
  import handleEmailSent from '@/logic/contact/handleEmailSent'

  // common components
  import ContainerBox from '@/components/LoginRegister/common/ContainerBox/v1/ContainerBox.vue'
  import Button from '@/components/LoginRegister/common/Button/v1/Button.vue'
  import Overlay from '@/components/LoginRegister/common/Overlay/v1/Overlay.vue'

  // composables
  import useLoading from '@/composables/useLoading'

  // state
  import email from '@/state/email'
  import showResetPopUp from '@/state/showResetPopUp'


  // Translations
  import { useI18n } from 'vue-i18n'
  const {t} = useI18n()


  const content = window.content

  // emit
  interface Emits {
    (e: 'buttonClick'): void
  }

  const emit = defineEmits<Emits>()

  // handlers
  const handleButtonClick = async () => {
    const { startLoadingThis, stopLoadingThis } = useLoading()
    showResetPopUp.value = false

    startLoadingThis()
    await resetPassword()

    stopLoadingThis()
    handleEmailSent()
  }

  onMounted(() => {
    // onKeyStroke
    const stop = onKeyStroke('Enter', () => {
      if (!email.value) return
      handleButtonClick()
    })
    onBeforeUnmount(() => stop())
  })
</script>

<style></style>
